import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CurrentProfilePrice, CurrentProfilePriceSearch, PageResource, PriceChangeHistory } from '@portal-front-end/models';
import { Observable } from 'rxjs';
import { API_SERVER_TOKEN } from '../api-server-token';

@Injectable({ providedIn: 'root' })
export class PriceChangeHistoryApiService {

    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly PRICE_CHANGE_API_URL = `${this.apiServer}/price-change-history`;

    getCurrentProfilePricing(productOrganisationId: number): Observable<PriceChangeHistory[]> {
        return this.http.get<PriceChangeHistory[]>(`${this.PRICE_CHANGE_API_URL}/${productOrganisationId}/current`);
    }

    getCurrentProfilePricingForOrg(orgainsationId: string, page: number, size: number, profileIds: number[] = [], search: CurrentProfilePriceSearch = null): Observable<PageResource<CurrentProfilePrice>>{
        const params: { [param: string]: string } = { 'page': page.toString(), 'size': size.toString() };
        if (profileIds.length) {
            params['profileIds'] = profileIds.join();
        }
        if (search?.organisationIds?.length) {
            params['organisationIds'] = search.organisationIds.join();
        }
        if (search?.effectiveDateFrom) {
            params['effectiveDateFrom'] = search.effectiveDateFrom;
        }
        if (search?.effectiveDateTo) {
            params['effectiveDateTo'] = search.effectiveDateTo;
        }
        if (search?.statusIds?.length) {
            params['statusIds'] = search.statusIds.join();
        }
        if (search?.orderCode) {
            params['orderCode'] = search.orderCode;
        }
        if (search?.supplierReference) {
            params['supplierReference'] = search.supplierReference;
        }
        return this.http.get<PageResource<CurrentProfilePrice>>(`${this.PRICE_CHANGE_API_URL}/current-for-org/${orgainsationId}/page`, { params });
    }

   
  // getPriceChangeHistoryForProfile(productOrganisationId: number, profileId: string): Observable<PriceChangeHistory[]> {
         //To Take 1 argument productOrganisationProfileId  

    getPriceChangeHistoryForProfile(productOrganisationProfileId: number): Observable<PriceChangeHistory[]> {
        //return this.http.get<PriceChangeHistory[]>(`${this.PRICE_CHANGE_API_URL}/${productOrganisationId}/${profileId}`);
        return this.http.get<PriceChangeHistory[]>(`${this.PRICE_CHANGE_API_URL}/${productOrganisationProfileId}`);
    }

    getPendingProfilePricingForOrg(productOrganisationId: number): Observable<PriceChangeHistory[]>{
        return this.http.get<PriceChangeHistory[]>(`${this.PRICE_CHANGE_API_URL}/${productOrganisationId}/pending`);
    }

    getMissingProfilePricingForOrg(productOrganisationId: number): Observable<PriceChangeHistory[]>{
        return this.http.get<PriceChangeHistory[]>(`${this.PRICE_CHANGE_API_URL}/${productOrganisationId}/missing`);
    }
}
